/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, View, type ViewStyle } from 'react-native';
import { surfaceCardStyles as styles } from './surfaceCards.styles';

export function BlockHeading(props: {
  label: string;
  description?: string;
  noTopMargin?: boolean;
  style?: ViewStyle;
}) {
  const { label, description, noTopMargin, style } = props;
  return (
    <View style={[styles.blockHeading, noTopMargin && { marginTop: 0 }, style]}>
      <Text style={styles.blockHeadingLabel}>{label}</Text>
      {description ? <Text style={styles.blockHeadingDescription}>{description}</Text> : null}
    </View>
  );
}
